<template>
  <div class="entity-select-field d-inline-flex flex-row align-baseline">
    <v-autocomplete
        outlined
        :dense="dense"
        :placeholder="placeholder"
        :label="label"
        :items="items"
        v-model="selectedItem"
        :loading="loading"
        :search-input.sync="searchTerm"
        hide-details="auto"
        :rules="rules"
        clearable
        :hide-no-data="true"
        :return-object="true"
        item-text="text"
        item-value="value.id"
        :filter="() => true"
        :append-icon="null"/>

    <user-select-dialog ref="userSelectDialog"
                          @selected="setSelected"/>
    <v-btn v-if="showSelectDialogButton"
           icon
           @click="openSelectDialog"
           :title="$t('entitySelect.selectFromList')">
      <v-icon>mdi-form-select</v-icon>
    </v-btn>

  </div>
</template>

<script>
import UserSelectDialog from '@/views/users/UserSelectDialog';
import UserService from '@/services/UserService';

export default {
  name: 'UserSelectField',
  components: { UserSelectDialog },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
    },
    label: {
      type: String,
    },
    showSelectDialogButton: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },

    rules: Array,
  },
  data: () => ({
    selectedItem: null,
    loading: false,
    searchTerm: null,
    timerId: null,
    entities: [],
  }),
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.valueComparator(this.value, val)) {
          return;
        }
        this.$emit('input', val);
        this.$emit('change', val);
      },
    },
    items() {
      const entitiesForSelection = this.entities.slice();

      if (this.selected && !entitiesForSelection.some(entity => entity.id === this.selected.id)) {
        entitiesForSelection.push(this.selected);
      }
      return entitiesForSelection.map(this.mapToItem);
    },
  },
  methods: {
    mapToItem(user) {
      return {
        text: this.$options.filters.user(user),
        value: user,
      };
    },


    valueComparator(one, two) {
      if (one == null && two == null) {
        return true;
      }
      if (one == null || two == null) {
        return false;
      }
      return one.id === two.id;
    },

    search() {
      if (!this.searchTerm) {
        this.entities = [];
        this.selectedItem = null;
        return;
      }
      if (this.selectedItem && this.searchTerm === this.selectedItem.text) {
        return;
      }

      this.loading = true;
      UserService.findByName(this.searchTerm).then(result => {
        this.entities = result.data;
      }).catch(err => {
        console.log(err);
      }).finally(() => (this.loading = false));
    },

    openSelectDialog() {
      this.$refs.userSelectDialog.show();
    },

    setSelected(user) {
      this.selected = user;
      this.$nextTick( ()=> this.setSelectionToAutoComplete(user));
    },
    setSelectionToAutoComplete(selected) {
      if (selected != null) {
        const item = this.mapToItem(selected);
        this.selectedItem = item;
        this.searchTerm = item.text;
      }
      else{
        this.selectedItem=null;
        this.searchTerm = null;
      }
    },

  },
  watch: {
    selectedItem(item) {
      if (item) {
        this.selected = item.value;
      } else {
        this.selected = null;
      }
    },
    selected(user) {
      this.setSelectionToAutoComplete(user);
    },

    searchTerm() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        this.search();
      }, 500);
    },
  },
  mounted() {
    if (this.selected) {
      this.setSelectionToAutoComplete(this.selected);
    }
  },
};
</script>

<style></style>
